/****************************************************************\

					   CORE RULES

	   This file is the entry point of the core module
			  for the rest of the application.
					 It work like an API
			  Choose wisely what you want to expose

			  Export only :
					 - initStore function
					 - type
					 - useCase hook
					 - selectors hook
					 - and ports

\****************************************************************/

import { useAuthSelectors } from "./src/slices/auth/useAuthSelectors";
import { useAuthUseCases } from "./src/slices/auth/useAuthUseCases";
import { useEtlDataSelectors } from "./src/slices/etlData/useEtlDataSelectors";
import { useEtlDataUseCases } from "./src/slices/etlData/useEtlDataUseCases";
import { useFormStepSelectors } from "./src/slices/formStep/useFormStepSelectors";
import { useFormStepUseCases } from "./src/slices/formStep/useFormStepUseCases";
import { useAppUseCases } from "./src/slices/app/useAppUseCases";
import { useUiUseCases } from "./src/slices/ui/useUiUseCases";
import { useNavigationSelectors } from "./src/slices/navigation/useNavigationSelectors";
import { useNavigationUseCases } from "./src/slices/navigation/useNavigationUseCases";
import { apiSlice } from "./src/store/rtk-instance";

/**
 * Init store and redux types
 */
export { initStore } from "./src/store/store";

/**
 * Types
 */
export * from "./src/store/store.types";

export const core = {
	useEtlDataUseCases,
	useEtlDataSelectors,
	useFormStepUseCases,
	useFormStepSelectors,
	useAuthSelectors,
	useAuthUseCases,
	useAppUseCases,
	useUiUseCases,
	useNavigationSelectors,
	useNavigationUseCases,
}

export type Core = typeof core;

/**
 * Ports
 */
export * from "./src/ports/etl-client.interface";
export * from "./src/ports/aw-client.interface";
export * from "./src/ports/local-storage.interface";
export * from "./src/ports/navigation-service.interface";

/**
 * Utils
 */
export * from "./src/utils/getMockedAdapters";
export type { ItemMapping } from "./src/slices/etlData/slice/etlData.types";

/**
 * Init state funtion
 */
export { etlDataReducerInit } from "./src/slices/etlData/slice/etlData.types";
export { formStepReducerInit } from "./src/slices/formStep/slice/formStep.type";

export const {
	useGetCsvUnzipperQuery,
	useGetFileUnzipperQuery,
	useGetCsvPreprocessorQuery,
	useGetFilesPreprocessorQuery,
	useGetFileCompetitorUploaderQuery,
	useGetFileCompetitorUploadedStatusQuery,
	useGetInputImporterQuery,
	useGetInputImporterPDFQuery,
	useGetExtractImportersQuery,
	useGetDictionaryGeneratorsQuery,
	useGetOutputCsvGeneratorsQuery,
	useGetOutputDataGeneratorsQuery,
	useGetSelectedEtlImportQuery,
	useUpdateSelectedEtlImportMutation,
	useLazyGetSelectedEtlImportQuery,
	useGetCsvUploaderQuery,
	useGetFileUploaderQuery,
	useGetOriginalFileUploaderQuery,
	useGetAwParserQuery,
} = apiSlice;
